import { preRedirectPage } from './pages/PreRedirectPage';
import { GtxApp } from 'gtx-react/components/GtxApp/GtxApp';

export const App = () => {
    return <GtxApp pages={[preRedirectPage]} />;
};
